//description: components interface that requires to have
//             - isUpdateRealTime property
//             - update() method to update the component with new data
//			   - onDataStreamAdded() method to be notified with when data stream is added for the containing widget
//			   - isNotInterestedInAnyDataFields() return true of component is not interested in any datafields
//			   - resize() is repeatedly called when widget resizes

import DataStore from "../../../../core/stores/dataStore.js";
import InternalEvent from "../../../../core/constants/internalEvent.js";
import InternalEventBus from "../../../../core/utils/internalEventBus.js";

module.exports = function (componentId, widgetId, legends) {
  // //////// private members
  var _this = this;
  var updateCallback = null;
  // var subscribed = [];
  var HISTORY_SIZE = 1;
  var eventTokens = [];

  // //////// public members
  this.id = componentId;

  function init() {
    let token = InternalEventBus.subscribe(InternalEvent.Dashboard.CHART_LEGEND_UPDATED, handleLegendUpdate);
    eventTokens.push(token);
  }

  function handleLegendUpdate(payload) {
    if (payload.widgetId !== widgetId) return;
    _this.update();
  }

  this.loadHistoricData = function (historicData) {
    if (updateCallback != null) {
      var value = this.prepareData(historicData);
      updateCallback(value);
    }
  };

  this.prepareData = function (historicData) {
    var datasetsData = {};
    for (var key in legends[0].mappings) {
      var datasetId = legends[0].mappings[key].datasetId;
      datasetsData[datasetId] = historicData ?
        historicData[datasetId][0] :
        DataStore.get(datasetId);
    }

    if (legends[0].hasOwnProperty("serverSideFunction")) {
      legends[0].serverSideFunction.map(ssf => {
        const requestId = ssf.requestId;
        datasetsData[requestId] = historicData[requestId][0];
      });
    }

    var value = 0;
    try {
      value = legends[0].functions.y(datasetsData);
    } catch (e) {
    }

    return value;
  };

  this.update = function () {
    if (updateCallback != null) {
      // var legend = legends[0];	// this widget is only interested in one field
      // var cachedStreamData = DataStore.get(legend.datasetId);
      // var newData = 0;
      // var fieldId = legend.valueFields.y;
      // if (!isNaN(cachedStreamData[fieldId])) {
      //     newData = cachedStreamData[fieldId];
      // }
      var value = this.prepareData();
      updateCallback(value);
    }
  };


  this.addUpdateListener = function (callback) {
    updateCallback = callback;
  }

  this.resize = function () {

  }

  this.onDataFieldsModified = function (allDataFields) {

  }

  // TODO: history size is how many data points does the chart display prior to start
  // updating itself on real-time updates. This value is hard-coded for now.
  this.getHistorySize = function () {
    return HISTORY_SIZE;
  }

  this.getLegends = function () {
    return legends;
  }

  this.destroy = function () {
    // for (var i = 0; i < subscribed.length; i++) {
    //     InternalEventBus.unsubscribe(subscribed[i], componentId);
    // }
    // subscribed = [];
  }

  init();
}


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/gauge/controller.js